import React from 'react';
import { useGetStayDuration } from 'src/hooks/useGetStayDuration';

export const useLiveStayDuration = (entryTime?: string, exitTime?: string) => {
    const { getDurationFromStartDateToEndDate } = useGetStayDuration();
    const today = new Date();
    const [duration, setDuration] = React.useState<string>('');

    React.useEffect(() => {
        setDuration(() => getDurationFromStartDateToEndDate({ startDate: entryTime, endDate: exitTime ?? String(today) }))
    }, [entryTime]);

    React.useEffect(() => {
        if (!entryTime || exitTime) return; // only update if active stay

        const interval = setInterval(() => {
            setDuration(getDurationFromStartDateToEndDate({ startDate: entryTime, endDate: exitTime }));
        }, 60_000);

        return () => clearInterval(interval);
    }, [entryTime, exitTime, getDurationFromStartDateToEndDate]);

    return duration;
};